import React from 'react';
import { motion } from 'framer-motion';
import { PrimaryButton, SecondaryButton } from './ui/UI';
import { Aurora } from './animations/Aurora';
import { BlurText } from './animations/BlurText';
import { DecryptedText } from './animations/DecryptedText';
import { ScrollFloat } from './animations/ScrollFloat';
import { Magnet } from './animations/Magnet';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative w-full py-40 border-t border-white/5 overflow-hidden" data-id="element-391">
      {/* Aurora wash for atmosphere */}
      <Aurora intensity={0.3} data-id="element-392" />

      {/* Background radar echo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-393">
        <motion.div className="absolute rounded-full opacity-20" style={{
        width: '80vmax',
        height: '80vmax',
        background: 'conic-gradient(from 0deg, transparent 0%, transparent 80%, rgba(26,143,212,0.05) 98%, rgba(26,143,212,0.4) 100%)'
      }} animate={{
        rotate: 360
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-394" />
        {[0, 1, 2].map(i => <motion.div key={i} className="absolute rounded-full border border-[#1a8fd4]/20" style={{
        width: '120px',
        height: '120px'
      }} animate={{
        scale: [1, 6],
        opacity: [0.4, 0]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        delay: i * 1.66,
        ease: 'linear'
      }} data-id="element-395" />)}
        <div className="absolute w-2 h-2 bg-[#1a8fd4] rounded-full shadow-[0_0_20px_#1a8fd4] animate-pulse" data-id="element-396" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-397">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-398">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1a8fd4]/10 border border-[#1a8fd4]/20 text-[#1a8fd4] text-xs font-mono uppercase tracking-widest mb-8" data-id="element-399">
            <span className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4] animate-pulse" data-id="element-400" />
            <DecryptedText text="FINAL" speed={50} data-id="element-401" />
          </span>

          {/* Headline with scroll-driven zoom */}
          <ScrollFloat scaleFrom={0.85} scaleTo={1} yFrom={40} data-id="element-402">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-semibold tracking-[-0.04em] leading-[0.95] text-white mb-8" data-id="element-403">
              <BlurText text="Know what" splitBy="word" data-id="element-404" />
              <br data-id="element-405" />
              <span className="text-white/40" data-id="element-406">
                <BlurText text="can compromise you." splitBy="word" delay={0.3} data-id="element-407" />
              </span>
            </h2>
          </ScrollFloat>

          <p className="text-xl md:text-2xl text-white/70 max-w-2xl mx-auto mb-4" data-id="element-408">
            Continuous security validation. Attack-path proof. AI app
            validation. Fix verification. Evidence packs. Priced like SaaS.
          </p>

          <p className="font-mono text-base text-[#1a8fd4] mb-12" data-id="element-409">
            <DecryptedText text="Find the path. Fix the risk. Prove it's gone." speed={30} data-id="element-410" />
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-411">
            <Magnet strength={0.3} data-id="element-412">
              <PrimaryButton href="#early-access" size="lg" data-id="element-413">
                Request Early Access
              </PrimaryButton>
            </Magnet>
            <Magnet strength={0.25} data-id="element-414">
              <SecondaryButton href="#jobs" size="lg" data-id="element-415">
                Join the Team
              </SecondaryButton>
            </Magnet>
          </div>
        </motion.div>
      </div>
    </section>;
}